// For each product on the page
document.querySelectorAll('.product').forEach(section => {
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);
    let quantity = 1;

    /************
     Development Debugging
     ************/
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

  let swiper = new Swiper(section.querySelector(".productVisualSwiper"), {
    slidesPerView: 1,
    spaceBetween: 60,
    centeredSlides: true,
    autoHeight: true,
    allowTouchMove: true,
    loop: false,
    keyboard: {
        enabled: true,
    },
    navigation: {
        nextEl: '.productVisualSwiperNext',
        prevEl: '.productVisualSwiperPrev',
    },
    breakpoints: {
        801: {
            slidesPerView: 1,           // ✅ 2 columnas en desktop
            spaceBetween: 20,           // Menos espacio entre imágenes
            centeredSlides: false,      // ✅ IMPORTANTE: evitar que se centren los 2 slides
            autoHeight: false           // ✅ Evita scroll vertical innecesario
        }
    },
    on: {
        slideChange: function () {
            section.querySelector(".productVisualThumbsSlide.active")?.classList.remove("active");
            section.querySelectorAll(".productVisualThumbsSlide")[this.realIndex]?.classList.add("active");
            section.querySelectorAll(".productVisualSwiperSlide video").forEach(video => video.pause());
        }
    }
});



    /************
     Video Playback on Click
     ************/
    section.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            const video = this.querySelector("video");
            if (!video) return;
            this.querySelector(".productVisualSwiperSlidePlay")?.remove();
            video.controls = true;
            video.play();
        });
    });

    /************
     Thumbnail Navigation
     ************/
    section.querySelectorAll(".productVisualThumbsSlide").forEach(element => {
        element.addEventListener("click", function () {
            const index = parseInt(this.dataset.index, 10);
            swiper.slideTo(index - 1);
        });
    });

    /************
     Variant Selection
     ************/
    section.querySelectorAll("input, select").forEach(element => {
        element.addEventListener("change", updateProduct);
    });

    /************
     Helper function to get variant image URL from selected label
     ************/
    function getVariantImageUrl(variant) {
        // Find the label that corresponds to this variant's option value
        if (variant && variant.options && variant.options[0]) {
            const optionValue = variant.options[0]; // Get the first option value (e.g., "Tropical Fruit Punch")
            
            // Find the label with this specific option value
            const labels = section.querySelectorAll('.productFormOptionsItemValuesLabel');
            for (let label of labels) {
                const input = label.querySelector('input');
                if (input && input.value === optionValue && label.dataset.imgurl) {
                    console.log('Found matching label for option:', optionValue, 'Image URL:', label.dataset.imgurl);
                    return label.dataset.imgurl;
                }
            }
        }
        
        // Fallback: try to find by variant featured image
        if (variant && variant.featured_image) {
            return variant.featured_image.src;
        }
        
        return null;
    }

    /************
     Update Product (Variant, Image, Price, ATC)
     ************/
    async function updateProduct() {
        console.log('updateProduct called');
        
        if (product.variants.length === 1) {
            activeVariant = product.variants[0];
        } else {
            let options = [];
            section.querySelectorAll(`.productFormOptionsItem`).forEach(group => {
                const checkedInput = group.querySelector(`input:checked`);
                if (checkedInput) {
                    options.push(checkedInput.value);
                }
            });
            console.log('Selected options:', options);
            activeVariant = product.variants.find(variant => JSON.stringify(variant.options) === JSON.stringify(options));
            console.log('Found variant:', activeVariant);
        }

        // Restore quantity to 1 before calculating price if switching to an available variant
        if (activeVariant && activeVariant.available && quantity < 1) {
            quantity = 1;
            section.querySelector(".productQuantityControlsValue").textContent = quantity;
        }

        if (!activeVariant) {
            section.querySelector(".productATCButton").disabled = true;
            section.querySelector(".productATCText").textContent = "Not Available";
            return;
        }

        // Update active variant image - Always go to first position (fake image) and update it
        const variantImageUrl = getVariantImageUrl(activeVariant);
        if (variantImageUrl) {
            console.log('Updating variant image:', variantImageUrl);
            
            // Always go to first position (index 0) - the fake image
            swiper.slideTo(0);
            
            // Update thumbnail active state to first position
            section.querySelector(".productVisualThumbsSlide.active")?.classList.remove("active");
            section.querySelectorAll(".productVisualThumbsSlide")[0]?.classList.add("active");
            
            // Update the fake image in gallery
            const galleryFakeImage = section.querySelector(".productVisualSwiperSlide.variant-img-gallery img");
            if (galleryFakeImage) {
                galleryFakeImage.src = variantImageUrl;
                console.log('Updated gallery fake image');
            }
            
            // Update the fake image in thumbnail
            const thumbFakeImage = section.querySelector(".productVisualThumbsSlide.variant-img-gallery img");
            if (thumbFakeImage) {
                thumbFakeImage.src = variantImageUrl.replace('width=1000', 'width=100');
                console.log('Updated thumbnail fake image');
            }
        } else {
            console.log('No image found for variant:', activeVariant);
        }

        const compareEl = section.querySelector(".productPriceCompare");
        const realEl = section.querySelector(".productPriceReal");

        compareEl.classList.remove('active');
        if (activeVariant.compare_at_price > activeVariant.price) {
            compareEl.textContent = price(activeVariant.compare_at_price * Math.max(1, quantity));
            compareEl.classList.add('active');
        }

        realEl.textContent = price(activeVariant.price * Math.max(1, quantity));

        const atcPrice = section.querySelector(".productATCPrice");
        if (atcPrice) atcPrice.textContent = price(activeVariant.price * Math.max(1, quantity));

        const atcBtn = section.querySelector(".productATCButton");
        const atcText = section.querySelector(".productATCText");
        const quantityElement = section.querySelector(".productQuantity");


        if (activeVariant.available) {
            atcBtn.disabled = false;
            atcText.textContent = "Add To Cart";
            quantityElement?.classList.add("is-visible");
            quantityElement?.classList.remove("is-hidden");
            section.querySelector(".productQuantityControlsBtn.minus").disabled = false;
            section.querySelector(".productQuantityControlsBtn.plus").disabled = false;
        } else {
            atcBtn.disabled = true;
            atcText.textContent = "Sold Out";
            quantity = 0;
            section.querySelector(".productQuantityControlsValue").textContent = quantity;
            quantityElement?.classList.remove("is-visible");
            quantityElement?.classList.add("is-hidden");
            section.querySelector(".productQuantityControlsBtn.minus").disabled = true;
            section.querySelector(".productQuantityControlsBtn.plus").disabled = true;
        }
    }

    // Initial update on load
    updateProduct();

    /************
     Label Active State
     ************/
    section.querySelectorAll('.productFormOptionsItemValuesLabelInput').forEach(input => {
        input.addEventListener('change', () => {
            const name = input.name;
            section.querySelectorAll(`input[name="${name}"]`).forEach(el => {
                el.closest('.productFormOptionsItemValuesLabel').classList.remove('active');
            });
            if (input.checked) {
                input.closest('.productFormOptionsItemValuesLabel').classList.add('active');
            }
        });

        if (input.checked) {
            input.closest('.productFormOptionsItemValuesLabel').classList.add('active');
        }
    });

    /************
     Quantity Controls
     ************/
    section.querySelector(".productQuantityControlsBtn.minus")?.addEventListener("click", function () {
        if (quantity === 1) return;
        quantity--;
        section.querySelector(".productQuantityControlsValue").textContent = quantity;
        updateProduct();
    });

    section.querySelector(".productQuantityControlsBtn.plus")?.addEventListener("click", function () {
        quantity++;
        section.querySelector(".productQuantityControlsValue").textContent = quantity;
        updateProduct();
    });

    /************
     Add To Cart
     ************/
    async function addToCart() {
        const atcBtn = section.querySelector(".productATCButton");
        atcBtn.classList.add("loading");

        const formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id
            }]
        };

        await addProduct(formData);
        atcBtn.classList.remove("loading");
        await openCart();
    }

    section.querySelector('.productATCButton').addEventListener("click", addToCart);

    /************
     Dropdown Toggle
     ************/
    section.querySelectorAll(".productDropdownToggle").forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });
});

/************
 Gradient Width Sync
 ************/
function setAllProductGradientWidths() {
    document.querySelectorAll('.product').forEach(section => {
        const productVisual = section.querySelector('.productVisual');
        const gradient = section.querySelector('.productGradient');

        if (productVisual && gradient) {
            const visualRight = productVisual.getBoundingClientRect().right;

            // width = from left edge of viewport (0) to right edge of .productVisual
            gradient.style.width = `${visualRight}px`;
        }
    });
}

window.addEventListener('load', setAllProductGradientWidths);
window.addEventListener('resize', () => {
    requestAnimationFrame(setAllProductGradientWidths);
});

/************
Bundle Products (Compre Junto) Functionality
************/

// Handle bundle product variant selection and add to cart
document.addEventListener('DOMContentLoaded', function() {
    const bundleSection = document.querySelector('.productCompreJunto');
    if (!bundleSection) return;

    // Store bundle products data
    const bundleProducts = {};
    
    // Initialize bundle products data
    bundleSection.querySelectorAll('.productCompreJuntoProduct').forEach(productCard => {
        const productId = productCard.dataset.productId;
        const variantSelect = productCard.querySelector('.productCompreJuntoProductVariantSelect');
        const atcButton = productCard.querySelector('.productCompreJuntoProductATCButton');
        const quantityInput = productCard.querySelector('.productCompreJuntoProductQuantityInput');
        
        if (productId) {
            bundleProducts[productId] = {
                card: productCard,
                variantSelect: variantSelect,
                atcButton: atcButton,
                quantityInput: quantityInput,
                currentVariantId: atcButton?.dataset.variantId,
                currentQuantity: 1
            };
        }
    });

    // Handle variant selection change
    bundleSection.querySelectorAll('.productCompreJuntoProductVariantSelect').forEach(select => {
        select.addEventListener('change', function() {
            const productId = this.dataset.productId;
            const variantId = this.value;
            const productData = bundleProducts[productId];
            
            console.log(`Variant changed: Product ${productId}, Variant ${variantId}`);
            
            if (productData) {
                // Update the add to cart button with new variant ID
                productData.atcButton.dataset.variantId = variantId;
                productData.currentVariantId = variantId;
                
                // Update price and availability
                updateBundleProductPrice(productId, variantId);
            }
        });
    });

    // Handle quantity input change
    bundleSection.querySelectorAll('.productCompreJuntoProductQuantityInput').forEach(input => {
        input.addEventListener('change', function() {
            const productId = this.closest('.productCompreJuntoProduct').dataset.productId;
            const quantity = parseInt(this.value) || 1;
            
            // Ensure minimum quantity of 1
            if (quantity < 1) {
                this.value = 1;
                bundleProducts[productId].currentQuantity = 1;
            } else {
                bundleProducts[productId].currentQuantity = quantity;
            }
        });
        
        input.addEventListener('input', function() {
            const productId = this.closest('.productCompreJuntoProduct').dataset.productId;
            const quantity = parseInt(this.value) || 1;
            
            // Ensure minimum quantity of 1
            if (quantity < 1) {
                this.value = 1;
                bundleProducts[productId].currentQuantity = 1;
            } else {
                bundleProducts[productId].currentQuantity = quantity;
            }
        });
    });

    // Handle add to cart for bundle products
    bundleSection.querySelectorAll('.productCompreJuntoProductATCButton').forEach(button => {
        button.addEventListener('click', async function() {
            const productId = this.dataset.productId;
            const variantId = this.dataset.variantId;
            const productData = bundleProducts[productId];
            
            if (!variantId) {
                console.error('No variant selected for product:', productId);
                return;
            }
            
            // Get current quantity
            const quantity = productData.currentQuantity || 1;
            
            await addBundleProductToCart(productId, variantId, this, quantity);
        });
    });

    // Handle add all to cart button
    const addAllButton = bundleSection.querySelector('.productCompreJuntoAddAllButton');
    if (addAllButton) {
        addAllButton.addEventListener('click', async function() {
            await addAllBundleProductsToCart(this);
        });
        
        // Check availability and update button state
        updateAddAllButtonState();
    }

    // Function to update bundle product price
    async function updateBundleProductPrice(productId, variantId) {
        try {
            // Get product handle from the product card
            const productCard = bundleProducts[productId].card;
            const productHandle = productCard.dataset.productHandle;
            
            if (!productHandle) {
                console.error('Product handle not found for product:', productId);
                return;
            }
            
            // Fetch product data from Shopify using handle
            const response = await fetch(`/products/${productHandle}.js`);
            if (!response.ok) throw new Error('Failed to fetch product data');
            
            const product = await response.json();
            
            // Find the specific variant
            const variant = product.variants.find(v => v.id.toString() === variantId.toString());
            
            if (!variant) {
                console.error('Variant not found:', variantId);
                return;
            }
            
            // Update price display
            const priceCurrent = productCard.querySelector('.productCompreJuntoProductPriceCurrent');
            const priceCompare = productCard.querySelector('.productCompreJuntoProductPriceCompare');
            
            if (priceCurrent) {
                priceCurrent.textContent = formatMoney(variant.price);
            }
            
            if (priceCompare && variant.compare_at_price > variant.price) {
                priceCompare.textContent = formatMoney(variant.compare_at_price);
                priceCompare.style.display = 'inline';
            } else if (priceCompare) {
                priceCompare.style.display = 'none';
            }
            
            // Update button state based on availability
            const atcButton = productCard.querySelector('.productCompreJuntoProductATCButton');
            const atcText = productCard.querySelector('.productCompreJuntoProductATCText');
            
            if (variant.available) {
                atcButton.disabled = false;
                atcText.textContent = 'Add To Cart';
            } else {
                atcButton.disabled = true;
                atcText.textContent = 'Coming soon';
            }
            
            // Update add all button state after variant change
            updateAddAllButtonState();
            
            // Debug log to verify the function is working
            console.log(`Product ${productId}, Variant ${variantId}: Available = ${variant.available}`);
            
        } catch (error) {
            console.error('Error updating bundle product price:', error);
        }
    }

    // Function to add bundle product to cart
    async function addBundleProductToCart(productId, variantId, button, quantity = 1) {
        const buttonText = button.querySelector('.productCompreJuntoProductATCText');
        const originalText = buttonText.textContent;
        
        try {
            // Show loading state
            button.disabled = true;
            buttonText.textContent = 'Adding...';
            
            // Prepare cart data
            const formData = {
                items: [{
                    quantity: quantity,
                    id: variantId
                }]
            };
            
            // Add to cart using existing function
            await addProduct(formData);
            
            // Show success state briefly
            buttonText.textContent = 'Added!';
            setTimeout(() => {
                buttonText.textContent = originalText;
                button.disabled = false;
            }, 1500);
            
            // Open cart
            await openCart();
            
        } catch (error) {
            console.error('Error adding bundle product to cart:', error);
            
            // Reset button state
            button.disabled = false;
            buttonText.textContent = originalText;
            
            // Show error message
            buttonText.textContent = 'Error';
            setTimeout(() => {
                buttonText.textContent = originalText;
            }, 2000);
        }
    }

    // Function to add all bundle products to cart
    async function addAllBundleProductsToCart(button) {
        const buttonText = button.querySelector('.productCompreJuntoAddAllText');
        const originalText = buttonText.textContent;
        
        try {
            // Show loading state
            button.disabled = true;
            buttonText.textContent = 'Adding All...';
            
            // Collect all available products with their quantities
            const itemsToAdd = [];
            let hasAvailableProducts = false;
            
            for (const [productId, productData] of Object.entries(bundleProducts)) {
                const variantId = productData.currentVariantId;
                const quantity = productData.currentQuantity || 1;
                const atcButton = productData.atcButton;
                
                // Only add if variant is available
                if (variantId && !atcButton.disabled) {
                    itemsToAdd.push({
                        quantity: quantity,
                        id: variantId
                    });
                    hasAvailableProducts = true;
                }
            }
            
            if (!hasAvailableProducts) {
                buttonText.textContent = 'No Available Products';
                setTimeout(() => {
                    buttonText.textContent = originalText;
                    button.disabled = false;
                }, 2000);
                return;
            }
            
            // Prepare cart data
            const formData = {
                items: itemsToAdd
            };
            
            // Add to cart using existing function
            await addProduct(formData);
            
            // Show success state briefly
            buttonText.textContent = 'All Added!';
            setTimeout(() => {
                buttonText.textContent = originalText;
                button.disabled = false;
            }, 1500);
            
            // Open cart
            await openCart();
            
        } catch (error) {
            console.error('Error adding all bundle products to cart:', error);
            
            // Reset button state
            button.disabled = false;
            buttonText.textContent = originalText;
            
            // Show error message
            buttonText.textContent = 'Error';
            setTimeout(() => {
                buttonText.textContent = originalText;
            }, 2000);
        }
    }

    // Function to update add all button state based on product availability
    function updateAddAllButtonState() {
        if (!addAllButton) return;
        
        const buttonText = addAllButton.querySelector('.productCompreJuntoAddAllText');
        let hasUnavailableProducts = false;
        let availableProductsCount = 0;
        
        // Check all products for availability
        for (const [productId, productData] of Object.entries(bundleProducts)) {
            const atcButton = productData.atcButton;
            if (atcButton && atcButton.disabled) {
                hasUnavailableProducts = true;
            } else if (atcButton && !atcButton.disabled) {
                availableProductsCount++;
            }
        }
        
        // Update button state and text
        if (hasUnavailableProducts) {
            addAllButton.disabled = true;
            buttonText.textContent = buttonText.dataset.unavailableText || 'Some Products Unavailable';
        } else if (availableProductsCount === 0) {
            addAllButton.disabled = true;
            buttonText.textContent = buttonText.dataset.noProductsText || 'No Products Available';
        } else {
            addAllButton.disabled = false;
            buttonText.textContent = buttonText.dataset.defaultText || 'Add All To Cart';
        }
    }

    // Helper function to format money (reuse existing logic)
    function formatMoney(cents) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        }).format(cents / 100);
    }
    
    // Function to update stars based on rating
    function updateStarsFromRating(container, rating) {
        const stars = container.querySelectorAll('.productCompreJuntoProductStar');
        const fullStars = Math.floor(rating);
        const partialStar = rating - fullStars;
        
        // Clear all stars first
        stars.forEach(star => {
            star.className = 'productCompreJuntoProductStar';
            star.textContent = '☆';
        });
        
        // Fill full stars
        for (let i = 0; i < fullStars && i < stars.length; i++) {
            stars[i].className = 'productCompreJuntoProductStar productCompreJuntoProductStar--filled';
            stars[i].textContent = '★';
        }
        
        // Handle partial star
        if (partialStar > 0 && fullStars < stars.length) {
            const partialStarElement = stars[fullStars];
            partialStarElement.className = 'productCompreJuntoProductStar productCompreJuntoProductStar--partial';
            partialStarElement.style.setProperty('--partial-width', `${partialStar * 100}%`);
            partialStarElement.innerHTML = `
                <span class="productCompreJuntoProductStar--partial-bg">★</span>
                <span class="productCompreJuntoProductStar--partial-fg">★</span>
            `;
        }
    }
    
    // Function to initialize star ratings
    function initStarRatings() {
        const starContainers = document.querySelectorAll('.productCompreJuntoProductStars[data-rating]');
        
        starContainers.forEach(container => {
            const rating = parseFloat(container.getAttribute('data-rating'));
            
            if (rating && rating > 0) {
                updateStarsFromRating(container, rating);
            }
        });
    }
    
    // Initialize star ratings when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initStarRatings);
    } else {
        initStarRatings();
    }
});

/************
Product Information Dropdowns
************/

// Product Information Dropdowns
function initProductInfoDropdowns() {
    console.log('Initializing dropdowns...');
    const dropdownToggles = document.querySelectorAll('.productInfoDropdownToggle');
    console.log('Found dropdown toggles:', dropdownToggles.length);
    
    dropdownToggles.forEach((toggle, index) => {
        console.log(`Setting up toggle ${index}:`, toggle);
        
        // Remove any existing event listeners to prevent duplicates
        toggle.removeEventListener('click', handleDropdownToggle);
        toggle.addEventListener('click', handleDropdownToggle);
        
        // Test if event listener was added
        console.log(`Toggle ${index} event listener added`);
    });
}

function handleDropdownToggle(event) {
    console.log('Dropdown toggle clicked:', this);
    event.preventDefault();
    event.stopPropagation();
    
    const targetId = this.getAttribute('data-target');
    const content = document.getElementById(targetId);
    const isActive = this.classList.contains('active');
    
    console.log('Target ID:', targetId);
    console.log('Content element:', content);
    console.log('Is active:', isActive);
    
    if (!content) {
        console.error('Dropdown content not found:', targetId);
        return;
    }
    
    // Close all other dropdowns
    const allToggles = document.querySelectorAll('.productInfoDropdownToggle');
    allToggles.forEach(otherToggle => {
        if (otherToggle !== this) {
            otherToggle.classList.remove('active');
            const otherTargetId = otherToggle.getAttribute('data-target');
            const otherContent = document.getElementById(otherTargetId);
            if (otherContent) {
                otherContent.classList.remove('active');
            }
        }
    });
    
    // Toggle current dropdown
    if (isActive) {
        this.classList.remove('active');
        content.classList.remove('active');
        console.log('Dropdown closed');
    } else {
        this.classList.add('active');
        content.classList.add('active');
        console.log('Dropdown opened');
    }
}

// Initialize dropdowns with 1 second delay
setTimeout(function() {
    console.log('Initializing dropdowns after 1 second delay...');
    initProductInfoDropdowns();
}, 1000);

// Re-initialize dropdowns when navigating between products (for SPA behavior)
document.addEventListener('shopify:section:load', function(event) {
    console.log('Shopify section loaded:', event.target);
    if (event.target.querySelector('.productInfoDropdowns')) {
        console.log('Re-initializing dropdowns...');
        initProductInfoDropdowns();
    }
});

// Additional fallback - re-initialize on any DOM changes
const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
            const addedNodes = Array.from(mutation.addedNodes);
            const hasDropdowns = addedNodes.some(node => 
                node.nodeType === 1 && 
                (node.classList?.contains('productInfoDropdowns') || 
                 node.querySelector?.('.productInfoDropdowns'))
            );
            
            if (hasDropdowns) {
                console.log('Dropdowns detected in DOM changes, re-initializing...');
                setTimeout(initProductInfoDropdowns, 100);
            }
        }
    });
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

// Debug: Check if script is running at all
console.log('Main product script loaded and running');


